import { Injectable, Inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from './api-request.service';
import { HttpParams} from '@angular/common/http';
import {NewUser, User} from '../../modules/user';

@Injectable()
export class UserService {

    constructor(
        private apiRequest: ApiRequestService,
    ) {}

  getUser(): Observable<any> {
    const subject = new Subject<any>();
    this.apiRequest.get('account/user')
      .subscribe(jsonResp => {
        subject.next(jsonResp);
      });
    return subject;
  }
  getUsersByPage(appid?: number, page?:number, size?:number): Observable<any> {
    let me = this;
    let params: HttpParams = new HttpParams();
    params = params.append('appid', appid.toString());
    params = params.append('page', typeof page === "number"? page.toString():"0");
    params = params.append('size', typeof size === "number"? size.toString():"20");

    let userListSubject = new Subject<any>(); // Will use this subject to emit data that we want

    this.apiRequest.get('account/users',params)
      .subscribe(jsonResp => {
        let items = jsonResp.items.map(function(v, i, a){
          let newRow = Object.assign({}, v, {
            address: `${v.address1}, <br/> ${v.city}, ${v.state} ${v.postalCode} <br/> ${v.country}`
          });

          return newRow;
        });

        let returnObj = Object.assign({},jsonResp,{
          items:items
        })
        userListSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
      });

    return userListSubject;
  }

  getUsers(page?:number, size?:number): Observable<any> {
        let me = this;
        let params: HttpParams = new HttpParams();
        params = params.append('page', typeof page === "number"? page.toString():"0");
        params = params.append('size', typeof size === "number"? size.toString():"1000");
        //params = params.append('size', size.toString() );
        let userListSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.get('account/users',params)
            .subscribe(jsonResp => {
                let items = jsonResp.items.map(function(v, i, a){
                    let newRow = Object.assign({}, v, {
                        address: `${v.address1}, <br/> ${v.city}, ${v.state} ${v.postalCode} <br/> ${v.country}`
                    });

                    return newRow;
                });

                let returnObj = Object.assign({},jsonResp,{
                    items:items
                })
                userListSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return userListSubject;
    }

  getRoles(): Observable<any> {
    const rolesSubject = new Subject<any>();
    this.apiRequest.get('app/allAppRoles' + '/test')
      .subscribe(jsonResp => {
        rolesSubject.next(jsonResp);
      });
    return rolesSubject;
  }
  getRolesByAppId(id: number): Observable<any> {
    const rolesSubject = new Subject<any>();
    this.apiRequest.get('app/allRoles/' + id)
      .subscribe(jsonResp => {
        rolesSubject.next(jsonResp);
      });
    return rolesSubject;
  }
  getAppRolesByUserId(id: number): Observable<any> {
    const rolesSubject = new Subject<any>();
    this.apiRequest.get('app/userAppRoles/' + id)
      .subscribe(jsonResp => {
        rolesSubject.next(jsonResp);
      });
    return rolesSubject;
  }
  getApps(): Observable<any> {
    const appListSubject = new Subject<any>();
    this.apiRequest.get('app/allApps')
      .subscribe(jsonResp => {
        appListSubject.next(jsonResp);
      });
    return appListSubject;
  }

  resetPwd(login: string, password: string): Observable<any> {
    let params =  {
      login: login,
      password: password
    };
    return this.apiRequest.post('account/resetPassword', params);
  }

  updateUser(user: User): Observable<any> {
    return this.apiRequest.post('account/update/user', user);
  }

  delUser(id: number): Observable<any> {
    return this.apiRequest.post('account/delete/user/', id);
  }

  saveUser(user: NewUser): Observable<any> {
    return this.apiRequest.post('account/add/user', user);
  }

  validateUser(name: string): Observable<any> {
    return this.apiRequest.get('account/validate/user/' + name);
  }
}
